// import homeDatasourceTrendAdapter from './home/homeDatasourceTrend'
// import homeDatasourceTrendNew from './home/homeDatasourceTrendNew'
// import hotelCemDemandResolution from './home/hotelCemDemandResolution'
// import hotelCemCustomerComplaintAlert from './home/hotelCemCustomerComplaintAlert'
// import hotelCemAlarmViewingRate from './home/hotelCemAlarmViewingRate'
// import voiceAnalysisAlarmRate from './voice-analysis/voiceAnalysisAlarmRate'
// import voiceAnalysisCheckRate from './voice-analysis/voiceAnalysisCheckRate'
// import voiceAnalysisLiveVoice from './voice-analysis/voiceAnalysisLiveVoice'
// import hotelcemTableIconChart from './voice-analysis/hotelcemTableIconChart'
// import commentChannelTotal from './comment-analysis/commentChannelTotal'
// import commentChannelValue from './comment-analysis/commentChannelValue'
// import commentChannelRate from './comment-analysis/commentChannelRate'
// import serviceQualityReviewData from './service-quality/serviceQualityReviewData'
// import serviceQualityVoiceData from './service-quality/serviceQualityVoiceData'
// import serviceQualityBusinessCircleRanking from './service-quality/serviceQualityBusinessCircleRanking'
// import commentAnalysisPieRate from './comment-analysis/commentAnalysisPieRate'
// // import hotelCemBusinessDistrictRanking from './home/hotelCemBusinessDistrictRanking'
// import hotelCemSubstandardExperiencePoint from './home/hotelCemSubstandardExperiencePoint'
// import serviceQualityExperiencePoints from './service-quality/serviceQualityExperiencePoints'
// import hotelCemComprehensiveExperienceScore from './home/hotelCemComprehensiveExperienceScore'
// import hotelcemQualityTrend from './service-quality/hotelcemQualityTrend'
// import homeComplaint from '@hotelcem/components/common-charts/adapter/home/homeComplaint'
// import voiceAnalysisComplaintRate from '@hotelcem/components/common-charts/adapter/voice-analysis/voiceAnalysisComplaintRate'
// import weeklyReportTreeMap from '@hotelcem/components/common-charts/adapter/reports/weeklyReportTreeMap'
// import hotelCemOTACommentScore from '@/hotelcem/components/common-charts/adapter/home/hotelCemOTACommentScore'
// import hotelCemOTACommentRank from '@/hotelcem/components/common-charts/adapter/home/hotelCemOTACommentRank'
// 竞争力趋势统计折线图
// import competeTrendChart from './comment-analysis/competeTrendChart'
// 自定义质检趋势图统计折线图
// import qualityTrendChart from './comment-analysis/qualityTrendChart'
// import industryAvgTrendChart from './comment-analysis/industryAvgTrendChart'
// 竞对排名趋势
// import serviceQualityRaceData from './service-quality/serviceQualityRaceData'

// import commentDatasourceTrend from './comment-analysis/commentDatasourceTrend'
// 部门质检排名
// import hotelcemDepartmentQualityTrend from './service-quality/hotelcemDepartmentQualityTrend'
// 住中语音总量
// import callOverviewData from './comment-analysis/callOverviewData'
// 住中语音分类
// import callClassificationData from './comment-analysis/callClassificationData'

// 公共圆环图
// import commonCircel from './home/commonCircel'
// import dataOverviewCSITrend from '@/hotelcem/components/common-charts/adapter/reports/dataOverviewCSITrend.js'
// import dataOverviewReviews from '@/hotelcem/components/common-charts/adapter/reports/dataOverviewReviews.js'
// import dataOverviewReviewsNumbers from '@/hotelcem/components/common-charts/adapter/reports/dataOverviewReviewsNumbers.js'
// import dataOverviewReplyRate from '@/hotelcem/components/common-charts/adapter/reports/dataOverviewReplyRate.js'
// import dataOverviewTOP from '@/hotelcem/components/common-charts/adapter/reports/dataOverviewTOP.js'
// import sublevelVoiceTotal from './comment-analysis/sublevelVoiceTotal'
// import commentSentiment from './reports/commentSentiment.js'

// 点评分布环图
// import commentDistrbution from './comment-analysis/commentDistrbution.js'

// 公共雷达图
// 雷达图区域上色
// import radarArea from './radar/radar-area.js'

// // 词云图
// import wordcloud from './wordcloud/index.js'

const mapping = {
  HomeDatasourceTrend: () => import('./home/homeDatasourceTrend'),
  homeDatasourceTrendNew: () => import('./home/homeDatasourceTrendNew'), //homeDatasourceTrendNew,
  HotelCemDemandResolution: () => import('./home/hotelCemDemandResolution'),
  HotelCemCustomerComplaintAlert: () => import('./home/hotelCemCustomerComplaintAlert'),
  HotelCemAlarmViewingRate: () => import('./home/hotelCemAlarmViewingRate'),
  VoiceAnalysisAlarmRate: () => import('./voice-analysis/voiceAnalysisAlarmRate'),
  VoiceAnalysisAlarmBarRate: () => import('./voice-analysis/voiceAnalysisAlarmBarRate'),
  VoiceAnalysisTimeBarRate: () => import('./voice-analysis/voiceAnalysisTimeBarRate'),
  VoiceAnalysisCheckRate: () => import('./voice-analysis/voiceAnalysisCheckRate'),
  VoiceAnalysisLiveVoice: () => import('./voice-analysis/voiceAnalysisLiveVoice'),
  HotelcemTableIconChart: () => import('./voice-analysis/hotelcemTableIconChart'),
  CommentChannelTotal: () => import('./comment-analysis/commentChannelTotal'),
  CommentChannelValue: () => import('./comment-analysis/commentChannelValue'),
  CommentChannelRate: () => import('./comment-analysis/commentChannelRate'),
  ServiceQualityReviewData: () => import('./service-quality/serviceQualityReviewData'),
  ServiceQualityVoiceData: () => import('./service-quality/serviceQualityVoiceData'),
  ServiceQualityBusinessCircleRanking: () => import('./service-quality/serviceQualityBusinessCircleRanking'),
  CommentAnalysisPieRate: () => import('./comment-analysis/commentAnalysisPieRate'),
  HotelCemBusinessDistrictRanking: () => import('./home/hotelCemBusinessDistrictRanking'),
  HotelCemSubstandardExperiencePoint: () => import('./home/hotelCemSubstandardExperiencePoint'),
  ServiceQualityExperiencePoints: () => import('./service-quality/serviceQualityExperiencePoints'),
  HotelCemComprehensiveExperienceScore: () => import('./home/hotelCemComprehensiveExperienceScore'),
  HotelcemQualityTrend: () => import('./service-quality/hotelcemQualityTrend'),
  HomeComplaint: () => import('../../../../hotelcem/components/common-charts/adapter/home/homeComplaint'),
  VoiceAnalysisComplaintRate: () =>
    import('@hotelcem/components/common-charts/adapter/voice-analysis/voiceAnalysisComplaintRate'),
  WeeklyReportTreeMap: () => import('@hotelcem/components/common-charts/adapter/reports/weeklyReportTreeMap'),
  CompeteTrendChart: () => import('./comment-analysis/competeTrendChart'),
  QualityTrendChart: () => import('./comment-analysis/qualityTrendChart'),
  IndustryAvgTrendChart: () => import('./comment-analysis/industryAvgTrendChart'),
  HotelCemOTACommentScore: () => import('@/hotelcem/components/common-charts/adapter/home/hotelCemOTACommentScore'),
  HotelCemOTACommentRank: () =>
    import('../../../../hotelcem/components/common-charts/adapter/home/hotelCemOTACommentRank'),
  CommentDatasourceTrend: () => import('./comment-analysis/commentDatasourceTrend'),
  ServiceQualityRaceData: () => import('./service-quality/serviceQualityRaceData'),
  HotelcemDepartmentQualityTrend: () => import('./service-quality/hotelcemDepartmentQualityTrend'),
  CallOverviewData: () => import('./comment-analysis/callOverviewData'),
  SublevelVoiceTotal: () => import('./comment-analysis/sublevelVoiceTotal'),
  CallClassificationData: () => import('./comment-analysis/callClassificationData'),
  CommonCircel: () => import('./home/commonCircel'),
  DataOverviewCSITrend: () => import('@/hotelcem/components/common-charts/adapter/reports/dataOverviewCSITrend.js'),
  DataOverviewReviews: () => import('@/hotelcem/components/common-charts/adapter/reports/dataOverviewReviews.js'),
  DataOverviewReviewsNumbers: () =>
    import('@/hotelcem/components/common-charts/adapter/reports/dataOverviewReviewsNumbers.js'),
  DataOverviewReplyRate: () => import('@/hotelcem/components/common-charts/adapter/reports/dataOverviewReplyRate.js'),
  DataOverviewTOP: () => import('@/hotelcem/components/common-charts/adapter/reports/dataOverviewTOP.js'),
  CommentSentiment: () => import('./reports/commentSentiment.js'),
  CommentTrendChart: () => import('./service-quality/commentTrendChart.js'),
  CommentNextLabelChart: () => import('./service-quality/commentNextLabelChart.js'),
  CommentDistrbution: () => import('./comment-analysis/commentDistrbution.js'),
  CommentScatterAnalysis: () => import('./service-quality/commentScatterAnalysis.js'),
  CommentTop10: () => import('./service-quality/commentTop10.js'),
  // 雷达图
  RadarArea: () => import('./radar/radar-area.js'),
  // 词云图
  Wordcloud: () => import('./wordcloud/index.js'),
  ComplaintTrend: () => import('./daily-report/complaintTrend.js'),
  CommonPieDoughnut: () => import('./pie/common-pie-doughnut.js'),
  HomeCommentScoreBar: () => import('./home-new/comment-score-bar.js'),
  HomeCommentIssueBarLine: () => import('./home-new/comment-issue-bar-line.js'),
  HomeCsiLine: () => import('./home-new/csi-line.js'),
  CompteSource: () => import('./compete/compete-source.js'),
  CompeteLineBar: () => import('./compete/compete-line-bar.js'),
  DemandKeyLine: () => import('./voice-analysis/demandKeyLine.js'),
  DemandMultLine: () => import('./voice-analysis/demandMultLine.js'),
}

const adapterMapping = async (type, dateRange, datas, attrs, resolve) => {
  if (!mapping[type]) {
    return
  }

  mapping[type]().then(module => {
    const res = module.default
    resolve(res(dateRange, datas, attrs))
  })
}

export default adapterMapping
